import type { PaletteColor, ThemeOptions } from "@mui/material";
import "./palette";


export const palette: Exclude<ThemeOptions["palette"], undefined> = {
	brand: {
		light: "#f20081",
		main: "#d40072",
		dark: "#7f0043",
		contrastText: "#fff",
		border: "#fc71bb",
	},
	dark: {
		dark: "#3d3d3d",
		main: "#3d3d3d",
		light: "#4f4f4f",
		contrastText: "#fff",
	},
	admin: {
		main: "#BC49EB",
		light: "#DBB5EB",
		dark: "#A905EB",
		contrastText: "#fff",
	},
	placeholder: {
		main: "#e4e6e9",
		light: "#eff0f2",
		contrastText: "#424242",
	},
};


declare module "@mui/material/styles" {
	interface Palette {
    brand: PaletteColor & {
			border: string;
		};
		admin: PaletteColor;
		dark: PaletteColor;
		placeholder: {
			main: string;
			light: string;
			contrastText: string;
		};
  }
	interface PaletteOptions {
		brand: PaletteColor & {
			border: string;
		};
		admin: PaletteColor;
		dark: PaletteColor;
		placeholder: {
			main: string;
			light: string;
			contrastText: string;
		};
	}
}

declare module "@mui/material/AppBar" {
	interface AppBarPropsColorOverrides {
		brand: true;
		dark: true;
		warning: true;
	}
}

declare module "@mui/material/Chip" {
	interface ChipPropsColorOverrides {
		brand: true;
		dark: true;
	}
}

declare module "@mui/material/Button" {
	interface ButtonPropsColorOverrides {
		brand: true;
	}
}

declare module "@mui/material/Fab" {
	interface FabPropsColorOverrides {
		dark: true;
		brand: true;
	}
}

declare module "@mui/material/SvgIcon" {
	interface SvgIconPropsColorOverrides {
		brand: true;
	}
}

declare module "@mui/material/IconButton" {
	interface IconButtonPropsColorOverrides {
		brand: true;
	}
}

declare module "@mui/material/Alert" {
	interface AlertPropsColorOverrides {
		brand: true;
	}
}
